

export function LoadingScreen() {
  return (
   
   <div className="flex justify-center items-center h-screen w-full bg-white">
  <div className="loader text-[50px] font-bold uppercase font-sans text-center max-w-4xl">
    One moment please — your onboarding is on the way!
  </div>
</div>

  );
}